import { BrowserRouter } from 'react-router-dom';
import {
  AuthProvider,
  NotificationHydrator,
  QueryProvider,
  RealtimeProvider,
  ThemeProvider,
} from './providers';
import { AppRouter } from './router/AppRouter';
import { ErrorBoundary } from '@components/common/ErrorBoundary';
// Register widgets (side-effect import triggers registry)
import '@widgets/registerAll';

export function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <BrowserRouter>
            <AuthProvider>
              <RealtimeProvider>
                <NotificationHydrator>
                  <AppRouter />
                </NotificationHydrator>
              </RealtimeProvider>
            </AuthProvider>
          </BrowserRouter>
        </ThemeProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
